import * as React from 'react'
import styled from '@emotion/styled'
require('../../../styles/global.css');
import { SocialIcon } from 'react-social-icons';
import BookingDates, {Dates} from "../BookingDates";
import Lightbox from 'lightbox-react';
import { GoChevronDown } from "react-icons/go";
import ReadMore from '../../react-read-more'
import ReadMoreTwo from '../../react-read-more-2'
import 'lightbox-react/style.css';
import AddLaundryLightbox from "./AddLaundryLightbox";
import Select, {components} from 'react-select'
import {useState, useEffect, ElementConfig} from "react";
import { GiDutchBike } from "react-icons/gi";
import { FormattedMessage } from 'react-intl';
import {fonts} from "../../../styles/variables";

const suiteImage = require('../../../../assets/images/booking/suite/suite_008.jpg')

const arrowDown = require('../../../../assets/images/down-arrow.png')



const customGuestStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: 'all .2s ease',
    transform: state.isFocused ? 'rotate(180deg)' : null,
    padding:'0px'
  }),
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      display: 'flex',
      borderRadius: '10rem',
      fontSize: '12px',
      width:'80px',
      borderTop: '1px solid lightgrey',
      borderLeft: '1px solid lightgrey',
      borderRight: '1px solid lightgrey',
      borderBottom: isFocused ? '2px solid #54aaf1' :'1px solid lightgrey',
      boxShadow: isFocused ? null : null,

      "&:hover": {
        // Overwrittes the different states of border
        borderColor: isFocused ? "none" : "rgba(68,68,68,.5)",


      }
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      background: isSelected ? 'rgb(24,140,236)' : 'white',
      color: isSelected ? 'white' : 'rgb(68,68,68)',
      cursor: isDisabled ? 'not-allowed' : 'default',
      "&:hover": {
        // Overwrittes the different states of border
        background: isSelected ? "rgba(24,140,236,1)" : "rgba(24,140,236,.2)",


      }

    };
  },



  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

const ArrowImg = styled.img`
fill:black !important;
width:12px;
height:12px;
margin: 0 11px 0 11px;

`


const DropdownIndicator = (
  props: ElementConfig<typeof components.DropdownIndicator>

) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowImg src={arrowDown}/>
    </components.DropdownIndicator>
  );
};


const Span = styled.span`
padding-left:6px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;
`

const BedsDiv = styled.div`
//width:150px;
text-align:left !important;
//width: 150px;

text-align: left !important;

padding-bottom: 22px;

@media screen and (max-width: 666px) {
width:80%;

margin-left:auto;
margin-right:auto;
}
`

const StyledBike = styled(GiDutchBike)`
width:24px;
height:24px;
position:absolute;
padding-bottom:2px;
color:black;
`
const BikesDiv = styled.div`
//width:150px;
text-align:left !important;
//width: 150px;
margin-right:14px;
text-align: left !important;

padding-bottom: 22px;

@media screen and (max-width: 666px) {
width:80%;
padding-bottom: 0px;

margin-left:auto;
margin-right:auto;
}
`
const StyledSelect = styled.div`
width:100%;
 font-family: "Theano Didot",Regular;
border-radius:0px !important;
font-size:16px;
text-align:center;





`
const StyledP = styled.p`
span{ font-family: ${fonts.standard} !important; 
      text-transform:none !important;
}
 font-family: "Theano Didot",Regular;
font-style: italic;
font-size: 140%;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
margin-bottom:0;
margin-left:36px;
//margin-top:10px;
text-align:left !important;
  @media screen and (max-width: 666px) {
display:none;
   }


`;



const Top = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
height:62%;
max-height:81.4px !important;

}
`

const StyledReadmore = styled(ReadMoreTwo)`
ul{
margin-bottom:0px;
}
`

const RadioDiv = styled.div`

height:70px;
display:flex;
align-items:center;

@media screen and (max-width:460px){
height:auto;

}

@media screen and (max-width:666px){
display:none;
}

`

const RadioSpan = styled.div`
padding-left:15px;
font-size:16px;
font-weight:700;
width:300px;

@media screen and (max-width:460px){
width:auto; 
}
`

const RadioGroupWrapper = styled.div`
margin-right:32px;
display: flex;
height: 100%;
align-items: center;
.btn-radio-laundry {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display:flex;
  align-items:center;
   padding-left:15px;
   height:70px;

}
.btn-radio-laundry:not(:first-child) {
  margin-left: 20px;
}

label:nth-child(2) {
  border-bottom:none !important;
}

@media screen and (max-width: 460px) {
  .btn-radio-laundry {
  
justify-content:space-between;
padding-right:10px;
  }
  .btn-radio-laundry:not(:first-child) {
    margin-left: 0;
  }
}
.btn-radio-laundry svg {
  fill: none;
  vertical-align: middle;
}
.btn-radio-laundry svg circle {
  stroke-width: 1.3;
  stroke: rgba(68,68,68);
}
.btn-radio-laundry svg path {
  stroke: rgb(24, 140, 236);
}
.btn-radio-laundry svg path.inner {
  stroke-width: 6;
  stroke-dasharray: 19;
  stroke-dashoffset: 19;
}
.btn-radio-laundry svg path.outer {
  stroke-width: 2;
  stroke-dasharray: 57;
  stroke-dashoffset: 57;
}
.btn-radio-laundry input {
  display: none;
}
.btn-radio-laundry input:checked + svg path {
  transition: all 0.4s ease;
}
.btn-radio-laundry input:checked + svg path.inner {
  stroke-dashoffset: 38;
  transition-delay: 0.3s;
}



.btn-radio-laundry input:checked + svg path.outer {
  stroke-dashoffset: 0;
}










.btn-radio-laundry{
width:100%;
}

`

const Img = styled.img`
width:auto;
cursor:pointer;
border-radius:2px;
display:block;
margin:0;
opacity:0.8;
transition: all .7s ease;
:hover{
opacity:1;
}


`

const ReadMoreButton = styled.div`
 display: flex;
align-items: center;
justify-content:center;
width:100%;
height:35%;
max-height:45.95px !important;
border-radius:2px;
//border-left:1px solid lightgrey;
//border-right:1px solid lightgrey;
//border-top:1px solid lightgrey;
//border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
//font-weight:bold;
font-size:19px;
background:rgba(84, 170, 241,.2);



  @media screen and (max-width: 666px) {
border-top:1px solid lightgrey;
   }



:hover{
letter-spacing:0px;
background:rgba(84, 170, 241,.3);
//border-top:1px solid  rgba(68,68,68,.03);



}
`

const ReadMoreButtonTwo = styled.div`
 display: flex;
align-items: center;
justify-content:center;
width:100%;
height:100%;
max-height:50px;
border-radius:2px;
//border-left:1px solid lightgrey;
//border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
//border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
//font-weight:bold;
font-size:19px;

  @media screen and (max-width: 666px) {
border-top:1px solid lightgrey;
   }



:hover{
background: rgba(68,68,68,.2);
letter-spacing:0px;



}
`



const Div = styled.div`
width:100%;
min-width:150px;
display:flex;

  @media screen and (max-width: 666px) {
  //display:block;
  height:auto;
  }
`



const Outer = styled.div`


 font-family: "Theano Didot",Regular;
width:100%;
 border:1px solid rgba(68,68,68,.04);  
  background: rgba(68,68,68,.02);
border-radius:2px;
//box-shadow: 1px 2px 4px rgba(0,0,0,.1);

height:auto;
-webkit-border-radius: 2px;
-moz-border-radius: 2px;
border-radius: 2px;


transition: all .3s ease;
:hover{
// box-shadow: 0 17.125px 50px -12.125px rgba(0,0,0,0.3);
 
 ${Img}{

opacity:1;
}
}
 `


const GreenOuter = styled.div`




margin-top:40px;
//border: 4px solid rgb(76, 175, 80);
height:auto;
-webkit-border-radius: 2px;
-moz-border-radius: 2px;
border-radius:2px;

 `


const Left = styled.div`
width: 34%;
display:block;
min-width:150px;
//border-right: 1px solid lightgrey;

 position: relative;
  text-align: center;

`



const StyledPMobile = styled.p`
 font-family: "Theano Didot",Regular;
font-style: italic;
font-size: 180%;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
margin-left:auto;
margin-right:auto;
margin-bottom:0px !important;
text-align:center !important;
display:none;


 @media screen and (max-width: 666px) {
display:none;
   }


`;

const A = styled.a`
`



const ShareButton = styled.div`
 display: flex;
align-items: center;
justify-content:center;
width:330px;
height:50px;
border-radius:2px;
border-left:1px solid lightgrey;
border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;

 @media screen and (max-width: 666px) {
display:none;
   }



:hover{
background: rgba(68,68,68,.2);
letter-spacing:0px;



}
`

const MobileShareButton = styled.div`
 display: flex;
align-items: center;
justify-content:center;width:330px;
height:50px;
border-radius:2px;
border-left:1px solid lightgrey;
border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
display:none;


 @media screen and (max-width: 666px) {
display:block;
   }



:hover{
background: rgba(68,68,68,.2);
letter-spacing:0px;



}
`


const ChooseButton = styled.div`
text-align:center;
width:100%;
height:50px;
border-radius:2px;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
font-size:19px;
border-top: 1px solid lightgrey;
//border-bottom: 1px solid lightgrey;
//border-left: 1px solid lightgrey;
//border-right: 1px solid lightgrey;
 display: flex;
align-items: center;
justify-content:center;
transition: all .7s ease;
background:rgb(24, 140, 236);
color:white;


:hover{
//color:white;
background:#188cec;
letter-spacing:0px;



}
`

const CheckIcon = styled.div`
color:white;
padding-left:10px;
`

const ReadMoreMobile = styled.div`

ul{
padding-top:15px;
padding-bottom:15px;
margin-bottom:0px;
padding-right:48px;
}


width: auto !important;
height: 35%;
max-height:auto;
opacity:1;  
 @media screen and (max-width: 666px) {
width: auto !important;
height: auto !important;
opacity:1;
   }
`

const ReadMoreDiv = styled.div`
width: 0px !important;
height: 0px !important;
opacity:0;

 .readmore.container{
padding-right:0.5rem;
}  



 @media screen and (max-width: 666px) {
width: 0px !important;
height: 0px !important;  
 opacity:0;}
   
`


const Right = styled.div`
width:66%;
display:block;

  @media screen and (max-width: 666px) {  }

`

const PDiv = styled.div`
height:100%;
//max-height:85.333px !important;
align-items:center;
display:flex;
justify-content:space-between;
cursor:pointer;
title:'Auswählen';
//border-right:1px solid lightgrey;;
//border-bottom:1px solid lightgrey;

  @media screen and (max-width: 666px) { 
   justify-content:center;

   }


:hover{

${StyledP}{
color:black;
}

.btn-radio svg circle{
stroke-width:1.6;
}
}
`

const Bottom = styled.div`
height:100%;
`


const Spn = styled.span`
padding-left:6px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase; 
 //float:left;

`

const SpnDiv = styled.span`
width:100%;
display:none;

  @media screen and (max-width: 666px) { 
display:flex;
margin-left: 2%;
   }
`


export class AddLaundry extends React.Component<any, any> {
  constructor (props) {
    super(props)

    this.state = {
      isSelected:props.isSelected,
      laundryValue: props.laundryValue,
      laundryOptions: props.laundryOptions,

    }

    //this.toggleSelection = this.toggleSelection.bind(this)
  }




  componentWillReceiveProps(nextProps) {
    if(!nextProps.isSelected) {
      this.setState({
        isSelected:nextProps.isSelected,


      })    }

    this.setState({
      laundryValue: nextProps.laundryValue,

      laundryOptions: nextProps.laundryOptions

    })




  }


  render () {
    return (
      <GreenOuter >
        <SpnDiv>
          <Spn>Laundry</Spn>
        </SpnDiv>
        <Outer>
          <Div>
            <Left>
              <StyledPMobile>Laundry</StyledPMobile>

              <AddLaundryLightbox/>


            </Left>
            <Right>
              <PDiv  >
                <StyledP ><FormattedMessage id="booking_fixed_box_16" /></StyledP>


                <RadioGroupWrapper className="cntr">

                  <BikesDiv>
                    <Span><FormattedMessage id="booking_text_15" /></Span>
                    <StyledSelect>
                      <Select
                        inputProps={{readOnly:true}}
                        styles={customGuestStyles} components={{ DropdownIndicator }} onChange={this.props.setLaundryFillings}
                              value={this.state.laundryValue}
                              clearable={false} options={this.state.laundryOptions}/>
                    </StyledSelect>
                  </BikesDiv>
                <RadioDiv >
                  <label htmlFor="rdo-laundry" className="btn-radio-laundry">
                    <RadioDiv  style={{color:this.props.isSelected ? 'rgb(24, 140, 236)':'rgb(68,68,68)'}}>
                      <input checked={this.props.isSelected}  type="radio" id="rdo-laundry" />
                      <svg width="20px" height="20px" viewBox="0 0 20 20">
                        <circle cx="10" cy="10" r="9"></circle>
                        <path
                          d="M10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 Z"
                          className="inner"></path>
                        <path
                          d="M10,1 L10,1 L10,1 C14.9705627,1 19,5.02943725 19,10 L19,10 L19,10 C19,14.9705627 14.9705627,19 10,19 L10,19 L10,19 C5.02943725,19 1,14.9705627 1,10 L1,10 L1,10 C1,5.02943725 5.02943725,1 10,1 L10,1 Z"
                          className="outer"></path>
                      </svg>
                    </RadioDiv>


                  </label>
                </RadioDiv>
                </RadioGroupWrapper>
              </PDiv>
            </Right>

          </Div>
      </Outer>
      </GreenOuter>
    )
  }
}


